import { GlobalState } from "@/Reducers/interface";
import {
	CreateCategoryRequest,
	ModifyCategoryRequest,
	ReorderCategoriesRequest
} from "@/Contracts/Assessments";
import {
	BlockType,
	QbrBlocks
} from "@/Contracts/ProposalBuilder/Block";
import {
	EditQbrDataLogRequest,
	HealthStatusDataLog,
	Qbr
} from "@/Contracts/QBR";

import { getBlock } from "@/ProposalBuilder/services/Block";
import {
	addQbrDataLog,
	createCategory,
	deleteCategory,
	deleteQbrDataLog,
	editQbrDataLog,
	editQbrDetails,
	getQbrDetails,
	reorderCategories,
	resetRiskScore,
	updateCategory
} from "@/Services/QBR";
import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";
import {
	UpdateBlockMapperRequestedAction,
	BlocksActionTypes,
	UpdateBlockMapperSuccessfulAction,
	UpdateBlockMapperFailedAction
} from "@/ProposalBuilder/store/actions/Blocks";
import { proposalBuilderStore } from "@/ProposalBuilder/store";

export enum QbrActionTypes {
	SHOW_QBR_LOADER = "SHOW_QBR_LOADER",
	HIDE_QBR_LOADER = "HIDE_QBR_LOADER",
	SHOW_QBR_LOG_LOADER = "SHOW_QBR_LOG_LOADER",
	HIDE_QBR_LOG_LOADER = "HIDE_QBR_LOG_LOADER",
	QBR_DETAILS_REQUESTED = "QBR_DETAILS_REQUESTED",
	QBR_DETAILS_SUCCESSFUL = "QBR_DETAILS_SUCCESSFUL",
	QBR_DETAILS_FAILED = "QBR_DETAILS_FAILED",
	EDIT_QBR_REQUESTED = "EDIT_QBR_REQUESTED",
	EDIT_QBR_SUCCESSFUL = "EDIT_QBR_SUCCESSFUL",
	EDIT_QBR_FAILED = "EDIT_QBR_FAILED",
	QBR_RESET = "QBR_RESET",
	QBR_DETAILS_RESET = "QBR_DETAILS_RESET",
	ADD_QBR_DATA_LOG_REQUESTED = "ADD_QBR_DATA_LOG_REQUESTED",
	ADD_QBR_DATA_LOG_SUCCESSFUL = "ADD_QBR_DATA_LOG_SUCCESSFUL",
	ADD_QBR_DATA_LOG_FAILED = "ADD_QBR_DATA_LOG_FAILED",
	EDIT_QBR_DATA_LOG_REQUESTED = "EDIT_QBR_DATA_LOG_REQUESTED",
	EDIT_QBR_DATA_LOG_FAILED = "EDIT_QBR_DATA_LOG_FAILED",
	EDIT_QBR_DATA_LOG_SUCCESSFUL = "EDIT_QBR_DATA_LOG_SUCCESSFUL",
	DELETE_QBR_DATA_LOG_REQUESTED = "DELETE_QBR_DATA_LOG_REQUESTED",
	DELETE_QBR_DATA_LOG_FAILED = "DELETE_QBR_DATA_LOG_FAILED",
	DELETE_QBR_DATA_LOG_SUCCESSFUL = "DELETE_QBR_DATA_LOG_SUCCESSFUL",
	CREATE_QBR_CATEGORY_REQUESTED = "CREATE_QBR_CATEGORY_REQUESTED",
	CREATE_QBR_CATEGORY_SUCCESSFUL = "CREATE_QBR_CATEGORY_SUCCESSFUL",
	CREATE_QBR_CATEGORY_FAILED = "CREATE_QBR_CATEGORY_FAILED",
	UPDATE_QBR_CATEGORY_REQUESTED = "UPDATE_QBR_CATEGORY_REQUESTED",
	UPDATE_QBR_CATEGORY_SUCCESS = "UPDATE_QBR_CATEGORY_SUCCESS",
	UPDATE_QBR_CATEGORY_FAILED = "UPDATE_QBR_CATEGORY_FAILED",
	DELETE_QBR_CATEGORY_REQUESTED = "DELETE_QBR_CATEGORY_REQUESTED",
	DELETE_QBR_CATEGORY_SUCCESS = "DELETE_QBR_CATEGORY_SUCCESS",
	DELETE_QBR_CATEGORY_FAILED = "DELETE_QBR_CATEGORY_FAILED",
	REORDER_QBR_CATEGORIES_REQUESTED = "REORDER_QBR_CATEGORIES_REQUESTED",
	REORDER_QBR_CATEGORIES_SUCCESS = "REORDER_QBR_CATEGORIES_SUCCESS",
	REORDER_QBR_CATEGORIES_FAILED = "REORDER_QBR_CATEGORIES_FAILED"
}

export type ShowQbrLoaderAction = Action<QbrActionTypes.SHOW_QBR_LOADER>;
export type HideQbrLoaderAction = Action<QbrActionTypes.HIDE_QBR_LOADER>;

export type ShowQbrLogLoaderAction = Action<QbrActionTypes.SHOW_QBR_LOG_LOADER>;
export type HideQbrLogLoaderAction = Action<QbrActionTypes.HIDE_QBR_LOG_LOADER>;

export type QbrDetailsRequestedAction =
	Action<QbrActionTypes.QBR_DETAILS_REQUESTED>;
export interface QbrDetailsSuccessfulAction
	extends Action<QbrActionTypes.QBR_DETAILS_SUCCESSFUL> {
	readonly currentActiveQbr: Qbr;
}
export type QbrDetailsFailedAction = Action<QbrActionTypes.QBR_DETAILS_FAILED>;

export type EditQbrDetailsRequestedAction =
	Action<QbrActionTypes.EDIT_QBR_REQUESTED>;
export interface EditQbrDetailsSuccessfulAction
	extends Action<QbrActionTypes.EDIT_QBR_SUCCESSFUL> {
	readonly currentActiveQbr: Qbr;
}
export type EditQbrDetailsFailedAction = Action<QbrActionTypes.EDIT_QBR_FAILED>;

export type QbrResetAction = Action<QbrActionTypes.QBR_RESET>;
export type QbrDetailsResetAction = Action<QbrActionTypes.QBR_DETAILS_RESET>;

export type AddQbrDataLogRequestedAction =
	Action<QbrActionTypes.ADD_QBR_DATA_LOG_REQUESTED>;
export interface AddQbrDataLogSuccessfulAction
	extends Action<QbrActionTypes.ADD_QBR_DATA_LOG_SUCCESSFUL> {
	readonly addQbrLog: HealthStatusDataLog;
}
export type AddQbrDataLogFailedAction =
	Action<QbrActionTypes.ADD_QBR_DATA_LOG_FAILED>;

export type EditQbrDataLogRequestedAction =
	Action<QbrActionTypes.EDIT_QBR_DATA_LOG_REQUESTED>;
export interface EditQbrDataLogSuccessfulAction
	extends Action<QbrActionTypes.EDIT_QBR_DATA_LOG_SUCCESSFUL> {
	readonly editQbrLog: HealthStatusDataLog;
}
export type EditQbrDataLogFailedAction =
	Action<QbrActionTypes.EDIT_QBR_DATA_LOG_FAILED>;

export type DeleteQbrDataLogRequestedAction =
	Action<QbrActionTypes.DELETE_QBR_DATA_LOG_REQUESTED>;

export interface DeleteQbrDataLogSuccessfulAction
	extends Action<QbrActionTypes.DELETE_QBR_DATA_LOG_SUCCESSFUL> {
	readonly deleteQbrLog: HealthStatusDataLog;
}
export type DeleteQbrDataLogFailedAction =
	Action<QbrActionTypes.DELETE_QBR_DATA_LOG_FAILED>;

export type CreateCategoryRequestedAction =
	Action<QbrActionTypes.CREATE_QBR_CATEGORY_REQUESTED>;
export interface CreateCategorySuccessfulAction
	extends Action<QbrActionTypes.CREATE_QBR_CATEGORY_SUCCESSFUL> {
	readonly currentActiveQbr: Qbr;
}
export type CreateCategoryFailedAction =
	Action<QbrActionTypes.CREATE_QBR_CATEGORY_FAILED>;

export type UpdateCategoryRequestedAction =
	Action<QbrActionTypes.UPDATE_QBR_CATEGORY_REQUESTED>;
export interface UpdateCategorySuccessfulAction
	extends Action<QbrActionTypes.UPDATE_QBR_CATEGORY_SUCCESS> {
	readonly currentActiveQbr: Qbr;
}
export type UpdateCategoryFailedAction =
	Action<QbrActionTypes.UPDATE_QBR_CATEGORY_FAILED>;

export type DeleteCategoryRequestedAction =
	Action<QbrActionTypes.DELETE_QBR_CATEGORY_REQUESTED>;
export interface DeleteCategorySuccessfulAction
	extends Action<QbrActionTypes.DELETE_QBR_CATEGORY_SUCCESS> {
	readonly currentActiveQbr: Qbr;
}
export type DeleteCategoryFailedAction =
	Action<QbrActionTypes.DELETE_QBR_CATEGORY_FAILED>;

export type ReorderCategoryRequestedAction =
	Action<QbrActionTypes.REORDER_QBR_CATEGORIES_REQUESTED>;
export interface ReorderCategoriesSuccessfulAction
	extends Action<QbrActionTypes.REORDER_QBR_CATEGORIES_SUCCESS> {
	readonly currentActiveQbr: Qbr;
}
export type ReorderCategoryFailedAction =
	Action<QbrActionTypes.REORDER_QBR_CATEGORIES_FAILED>;

export type QbrActions =
	| ShowQbrLoaderAction
	| HideQbrLoaderAction
	| ShowQbrLogLoaderAction
	| HideQbrLogLoaderAction
	| QbrDetailsRequestedAction
	| QbrDetailsSuccessfulAction
	| QbrDetailsFailedAction
	| EditQbrDetailsRequestedAction
	| EditQbrDetailsSuccessfulAction
	| EditQbrDetailsFailedAction
	| QbrResetAction
	| QbrDetailsResetAction
	| AddQbrDataLogRequestedAction
	| AddQbrDataLogSuccessfulAction
	| AddQbrDataLogFailedAction
	| EditQbrDataLogRequestedAction
	| EditQbrDataLogSuccessfulAction
	| EditQbrDataLogFailedAction
	| DeleteQbrDataLogRequestedAction
	| DeleteQbrDataLogSuccessfulAction
	| DeleteQbrDataLogFailedAction
	| CreateCategoryRequestedAction
	| CreateCategorySuccessfulAction
	| CreateCategoryFailedAction
	| UpdateCategoryRequestedAction
	| UpdateCategorySuccessfulAction
	| UpdateCategoryFailedAction
	| DeleteCategoryRequestedAction
	| DeleteCategorySuccessfulAction
	| DeleteCategoryFailedAction
	| ReorderCategoryRequestedAction
	| ReorderCategoriesSuccessfulAction
	| ReorderCategoryFailedAction;

interface HealthStatusDataLogRequest<T> {
	requestPayload: T;
	updateQbrBlocks: boolean;
}

export interface QbrDispatch {
	showQbrLoader: ActionCreator<
		ThunkAction<ShowQbrLoaderAction, GlobalState, null, ShowQbrLoaderAction>
	>;
	hideQbrLoader: ActionCreator<
		ThunkAction<HideQbrLoaderAction, GlobalState, null, HideQbrLoaderAction>
	>;
	showQbrLogLoader: ActionCreator<
		ThunkAction<
			ShowQbrLogLoaderAction,
			GlobalState,
			null,
			ShowQbrLogLoaderAction
		>
	>;
	hideQbrLogLoader: ActionCreator<
		ThunkAction<
			HideQbrLogLoaderAction,
			GlobalState,
			null,
			HideQbrLogLoaderAction
		>
	>;
	getQbrDetails: ActionCreator<
		ThunkAction<
			Promise<QbrDetailsSuccessfulAction>,
			GlobalState,
			string,
			QbrDetailsSuccessfulAction
		>
	>;
	editQbrDetails: ActionCreator<
		ThunkAction<
			Promise<EditQbrDetailsSuccessfulAction>,
			GlobalState,
			Qbr,
			EditQbrDetailsSuccessfulAction
		>
	>;
	resetQbrs: ActionCreator<
		ThunkAction<QbrResetAction, GlobalState, null, QbrResetAction>
	>;
	resetQbrDetails: ActionCreator<
		ThunkAction<
			QbrDetailsResetAction,
			GlobalState,
			null,
			QbrDetailsResetAction
		>
	>;
	resetRiskScore: ActionCreator<
		ThunkAction<
			Promise<EditQbrDetailsSuccessfulAction>,
			GlobalState,
			string,
			EditQbrDetailsSuccessfulAction
		>
	>;
	addQbrDataLog: ActionCreator<
		ThunkAction<
			Promise<AddQbrDataLogSuccessfulAction>,
			GlobalState,
			HealthStatusDataLogRequest<HealthStatusDataLog>,
			AddQbrDataLogSuccessfulAction
		>
	>;
	editQbrDataLog: ActionCreator<
		ThunkAction<
			Promise<EditQbrDataLogSuccessfulAction>,
			GlobalState,
			HealthStatusDataLogRequest<EditQbrDataLogRequest>,
			EditQbrDataLogSuccessfulAction
		>
	>;
	deleteQbrDataLog: ActionCreator<
		ThunkAction<
			Promise<DeleteQbrDataLogSuccessfulAction>,
			GlobalState,
			HealthStatusDataLog,
			DeleteQbrDataLogSuccessfulAction
		>
	>;
	createCategory: ActionCreator<
		ThunkAction<
			Promise<CreateCategorySuccessfulAction>,
			GlobalState,
			CreateCategoryRequest,
			CreateCategorySuccessfulAction
		>
	>;
	updateCategory: ActionCreator<
		ThunkAction<
			Promise<UpdateCategorySuccessfulAction>,
			GlobalState,
			ModifyCategoryRequest,
			UpdateCategorySuccessfulAction
		>
	>;
	deleteCategory: ActionCreator<
		ThunkAction<
			Promise<DeleteCategorySuccessfulAction>,
			GlobalState,
			ModifyCategoryRequest,
			DeleteCategorySuccessfulAction
		>
	>;
	reorderCategories: ActionCreator<
		ThunkAction<
			Promise<ReorderCategoriesSuccessfulAction>,
			GlobalState,
			ReorderCategoriesRequest,
			ReorderCategoriesSuccessfulAction
		>
	>;
}

const getUpdatedQbrBlocks = async (
	_state: GlobalState,
	{ riskMatrix, riskScore, healthStatus }: QbrBlocks
) => {
	const proposalBuilderState = proposalBuilderStore.getState();
	const riskMatrixBlock = Object.values(
		proposalBuilderState.blocks.blockMapper
	).filter(block => block.type === BlockType.RISK_MATRIX);
	const riskBarBlock = Object.values(
		proposalBuilderState.blocks.blockMapper
	).filter(block => block.type === BlockType.RISK_BAR);
	const healthStatusBlocks = Object.values(
		proposalBuilderState.blocks.blockMapper
	).filter(block => block.type === BlockType.HEALTH_STATUS);
	const healthLegendBlock = Object.values(
		proposalBuilderState.blocks.blockMapper
	).filter(block => block.type === BlockType.HEALTH_LEGEND);

	let newBlockMapper = { ...proposalBuilderState.blocks.blockMapper };
	// fetch new risk matrix
	if (riskMatrixBlock[0]?.id && riskMatrix) {
		const newRiskMatrix = await getBlock(riskMatrixBlock[0].id);
		newBlockMapper = {
			...newBlockMapper,
			[newRiskMatrix.id]: newRiskMatrix
		};
	}

	// fetch new risk bar
	if (riskBarBlock[0]?.id && riskScore) {
		const newRiskBar = await getBlock(riskBarBlock[0].id);
		newBlockMapper = { ...newBlockMapper, [newRiskBar.id]: newRiskBar };
	}

	// fetch new health status
	for (let i = 0; i < healthStatusBlocks.length; i++) {
		if (healthStatusBlocks[i]?.id && healthStatus) {
			const newHealthStatus = await getBlock(healthStatusBlocks[i].id);
			newBlockMapper = {
				...newBlockMapper,
				[newHealthStatus.id]: newHealthStatus
			};
		}
	}

	if (healthLegendBlock[0]?.id && healthStatus) {
		const newHealthLegend = await getBlock(healthLegendBlock[0].id);
		newBlockMapper = {
			...newBlockMapper,
			[newHealthLegend.id]: newHealthLegend
		};
	}

	return newBlockMapper;
};

export const QbrActionCreators: QbrDispatch = {
	showQbrLoader: () => {
		return (dispatch: Dispatch): ShowQbrLoaderAction => {
			const showQbrLoaderAction: ShowQbrLoaderAction = {
				type: QbrActionTypes.SHOW_QBR_LOADER
			};
			return dispatch(showQbrLoaderAction);
		};
	},
	hideQbrLoader: () => {
		return (dispatch: Dispatch): HideQbrLoaderAction => {
			const hideQbrLoaderAction: HideQbrLoaderAction = {
				type: QbrActionTypes.HIDE_QBR_LOADER
			};
			return dispatch(hideQbrLoaderAction);
		};
	},
	showQbrLogLoader: () => {
		return (dispatch: Dispatch): ShowQbrLogLoaderAction => {
			const showQbrLogLoaderAction: ShowQbrLogLoaderAction = {
				type: QbrActionTypes.SHOW_QBR_LOG_LOADER
			};
			return dispatch(showQbrLogLoaderAction);
		};
	},
	hideQbrLogLoader: () => {
		return (dispatch: Dispatch): HideQbrLogLoaderAction => {
			const hideQbrLogLoaderAction: HideQbrLogLoaderAction = {
				type: QbrActionTypes.HIDE_QBR_LOG_LOADER
			};
			return dispatch(hideQbrLogLoaderAction);
		};
	},
	getQbrDetails: (qbrId: string, appendQueryParamAuth = false) => {
		return async (
			dispatch: Dispatch
		): Promise<QbrDetailsSuccessfulAction> => {
			const qbrDetailsRequestedAction: QbrDetailsRequestedAction = {
				type: QbrActionTypes.QBR_DETAILS_REQUESTED
			};
			dispatch(qbrDetailsRequestedAction);
			try {
				const qbrDetailsResponse = await getQbrDetails(
					qbrId,
					appendQueryParamAuth
				);
				const qbrDetailsSuccessfulAction: QbrDetailsSuccessfulAction = {
					type: QbrActionTypes.QBR_DETAILS_SUCCESSFUL,
					currentActiveQbr: qbrDetailsResponse
				};
				return dispatch(qbrDetailsSuccessfulAction);
			} catch (error) {
				const qbrDetailsFailedAction: QbrDetailsFailedAction = {
					type: QbrActionTypes.QBR_DETAILS_FAILED
				};
				dispatch(qbrDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editQbrDetails: (qbr: Qbr) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<EditQbrDetailsSuccessfulAction> => {
			const editQbrDetailsRequestedActions: EditQbrDetailsRequestedAction =
				{
					type: QbrActionTypes.EDIT_QBR_REQUESTED
				};
			dispatch(editQbrDetailsRequestedActions);
			try {
				const editQbrDetailsResponse = await editQbrDetails(qbr);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedQbrBlocks(state, {
						riskMatrix: true,
						riskScore: true,
						healthStatus: false
					});
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const editQbrDetailsSuccessfulAction: EditQbrDetailsSuccessfulAction =
					{
						type: QbrActionTypes.EDIT_QBR_SUCCESSFUL,
						currentActiveQbr: editQbrDetailsResponse
					};
				return dispatch(editQbrDetailsSuccessfulAction);
			} catch (error) {
				const editQbrDetailsFailedAction: EditQbrDetailsFailedAction = {
					type: QbrActionTypes.EDIT_QBR_FAILED
				};
				dispatch(editQbrDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetQbrs: () => {
		return (dispatch: Dispatch): QbrResetAction => {
			const assessmentsResetAction: QbrResetAction = {
				type: QbrActionTypes.QBR_RESET
			};
			return dispatch(assessmentsResetAction);
		};
	},
	resetQbrDetails: () => {
		return (dispatch: Dispatch): QbrDetailsResetAction => {
			const assessmentDetailsResetAction: QbrDetailsResetAction = {
				type: QbrActionTypes.QBR_DETAILS_RESET
			};
			return dispatch(assessmentDetailsResetAction);
		};
	},
	resetRiskScore: (qbrId: string) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<EditQbrDetailsSuccessfulAction> => {
			const editQbrDetailsRequestedActions: EditQbrDetailsRequestedAction =
				{
					type: QbrActionTypes.EDIT_QBR_REQUESTED
				};
			dispatch(editQbrDetailsRequestedActions);
			try {
				const editQbrDetailsResponse = await resetRiskScore(qbrId);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedQbrBlocks(state, {
						riskMatrix: false,
						riskScore: true,
						healthStatus: false
					});

					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const editQbrDetailsSuccessfulAction: EditQbrDetailsSuccessfulAction =
					{
						type: QbrActionTypes.EDIT_QBR_SUCCESSFUL,
						currentActiveQbr: editQbrDetailsResponse
					};
				return dispatch(editQbrDetailsSuccessfulAction);
			} catch (error) {
				const editQbrDetailsFailedAction: EditQbrDetailsFailedAction = {
					type: QbrActionTypes.EDIT_QBR_FAILED
				};
				dispatch(editQbrDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addQbrDataLog: (qbrLog: HealthStatusDataLog, updateQbrBlocks = true) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<AddQbrDataLogSuccessfulAction> => {
			const addQbrDataLogRequestedAction: AddQbrDataLogRequestedAction = {
				type: QbrActionTypes.ADD_QBR_DATA_LOG_REQUESTED
			};
			dispatch(addQbrDataLogRequestedAction);
			try {
				const state = getState();
				const qbrId = state.qbr.currentActiveQbr?.id;
				if (!qbrId) {
					throw new Error(
						"QBR Data Log add without currentActiveQbr"
					);
				}
				const addQbrDataLogResponse = await addQbrDataLog(
					qbrLog,
					qbrId
				);
				if (updateQbrBlocks) {
					const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperRequestedAction
					);
					try {
						const newBlockMapper = await getUpdatedQbrBlocks(
							state,
							{
								riskMatrix: true,
								riskScore: true,
								healthStatus: true
							}
						);
						const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
								blockMapper: newBlockMapper
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperSuccessfulAction
						);
					} catch (error) {
						const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperFailedAction
						);

						return Promise.reject(error);
					}
				}
				const addQbrDataLogSuccessfulAction: AddQbrDataLogSuccessfulAction =
					{
						type: QbrActionTypes.ADD_QBR_DATA_LOG_SUCCESSFUL,
						addQbrLog: addQbrDataLogResponse
					};
				return dispatch(addQbrDataLogSuccessfulAction);
			} catch (error) {
				const addQbrLogFailedAction: AddQbrDataLogFailedAction = {
					type: QbrActionTypes.ADD_QBR_DATA_LOG_FAILED
				};
				dispatch(addQbrLogFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editQbrDataLog: (
		editQbrLogRequest: EditQbrDataLogRequest,
		updateQbrBlocks = true
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<EditQbrDataLogSuccessfulAction> => {
			const editQbrDataLogRequestedAction: EditQbrDataLogRequestedAction =
				{
					type: QbrActionTypes.EDIT_QBR_DATA_LOG_REQUESTED
				};
			dispatch(editQbrDataLogRequestedAction);
			try {
				const state = getState();
				const qbrId = state.qbr.currentActiveQbr?.id;
				if (!qbrId) {
					throw new Error(
						"QBR Data Log update without currentActiveQbr"
					);
				}
				const editQbrLogResponse = await editQbrDataLog(
					editQbrLogRequest,
					qbrId
				);
				if (updateQbrBlocks) {
					const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperRequestedAction
					);
					try {
						const newBlockMapper = await getUpdatedQbrBlocks(
							state,
							{
								riskMatrix: true,
								riskScore: true,
								healthStatus: true
							}
						);
						const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
								blockMapper: newBlockMapper
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperSuccessfulAction
						);
					} catch (error) {
						const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperFailedAction
						);

						return Promise.reject(error);
					}
				}
				const editQbrDataLogSuccessfulAction: EditQbrDataLogSuccessfulAction =
					{
						type: QbrActionTypes.EDIT_QBR_DATA_LOG_SUCCESSFUL,
						editQbrLog: editQbrLogResponse
					};
				return dispatch(editQbrDataLogSuccessfulAction);
			} catch (error) {
				const editQbrLogFailedAction: EditQbrDataLogFailedAction = {
					type: QbrActionTypes.EDIT_QBR_DATA_LOG_FAILED
				};
				dispatch(editQbrLogFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteQbrDataLog: (qbrDataLog: HealthStatusDataLog) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<DeleteQbrDataLogSuccessfulAction> => {
			const deleteQbrDataLogRequestedAction: DeleteQbrDataLogRequestedAction =
				{
					type: QbrActionTypes.DELETE_QBR_DATA_LOG_REQUESTED
				};
			dispatch(deleteQbrDataLogRequestedAction);
			try {
				const state = getState();
				const qbrId = state.qbr.currentActiveQbr?.id;
				if (!qbrId) {
					throw new Error(
						"Qbr Data Log delete without currentActiveQbr"
					);
				}
				await deleteQbrDataLog(qbrId, qbrDataLog.id);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const newBlockMapper = await getUpdatedQbrBlocks(state, {
						riskMatrix: true,
						riskScore: true,
						healthStatus: true
					});
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const deleteQbrDataLogSuccessfulAction: DeleteQbrDataLogSuccessfulAction =
					{
						type: QbrActionTypes.DELETE_QBR_DATA_LOG_SUCCESSFUL,
						deleteQbrLog: qbrDataLog
					};
				return dispatch(deleteQbrDataLogSuccessfulAction);
			} catch (error) {
				const deleteQbrDataLogFailedAction: DeleteQbrDataLogFailedAction =
					{
						type: QbrActionTypes.DELETE_QBR_DATA_LOG_FAILED
					};
				dispatch(deleteQbrDataLogFailedAction);

				return Promise.reject(error);
			}
		};
	},
	createCategory: (createCategoryRequest: CreateCategoryRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<CreateCategorySuccessfulAction> => {
			const createCategoryRequestedAction: CreateCategoryRequestedAction =
				{
					type: QbrActionTypes.CREATE_QBR_CATEGORY_REQUESTED
				};
			dispatch(createCategoryRequestedAction);
			try {
				const createCategoryResponse = await createCategory(
					createCategoryRequest
				);
				const createCategorySuccessfulAction: CreateCategorySuccessfulAction =
					{
						type: QbrActionTypes.CREATE_QBR_CATEGORY_SUCCESSFUL,
						currentActiveQbr: createCategoryResponse
					};
				return dispatch(createCategorySuccessfulAction);
			} catch (error) {
				const createCategoryFailedAction: CreateCategoryFailedAction = {
					type: QbrActionTypes.CREATE_QBR_CATEGORY_FAILED
				};
				dispatch(createCategoryFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateCategory: (modifyCategoryRequest: ModifyCategoryRequest) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateCategorySuccessfulAction> => {
			const updateCategoryRequestedAction: UpdateCategoryRequestedAction =
				{
					type: QbrActionTypes.UPDATE_QBR_CATEGORY_REQUESTED
				};
			dispatch(updateCategoryRequestedAction);
			try {
				const updateCategoryResponse = await updateCategory(
					modifyCategoryRequest
				);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedQbrBlocks(state, {
						riskMatrix: true,
						riskScore: true,
						healthStatus: true
					});
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const updateCategorySuccessfulAction: UpdateCategorySuccessfulAction =
					{
						type: QbrActionTypes.UPDATE_QBR_CATEGORY_SUCCESS,
						currentActiveQbr: updateCategoryResponse
					};
				return dispatch(updateCategorySuccessfulAction);
			} catch (error) {
				const updateCategoryFailedAction: UpdateCategoryFailedAction = {
					type: QbrActionTypes.UPDATE_QBR_CATEGORY_FAILED
				};
				dispatch(updateCategoryFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteCategory: (modifyCategoryRequest: ModifyCategoryRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteCategorySuccessfulAction> => {
			const deleteCategoryRequestedAction: DeleteCategoryRequestedAction =
				{
					type: QbrActionTypes.DELETE_QBR_CATEGORY_REQUESTED
				};
			dispatch(deleteCategoryRequestedAction);
			try {
				const deleteCategoryResponse = await deleteCategory(
					modifyCategoryRequest
				);
				const deleteCategorySuccessfulAction: DeleteCategorySuccessfulAction =
					{
						type: QbrActionTypes.DELETE_QBR_CATEGORY_SUCCESS,
						currentActiveQbr: deleteCategoryResponse
					};
				return dispatch(deleteCategorySuccessfulAction);
			} catch (error) {
				const deleteCategoryFailedAction: DeleteCategoryFailedAction = {
					type: QbrActionTypes.DELETE_QBR_CATEGORY_FAILED
				};
				dispatch(deleteCategoryFailedAction);

				return Promise.reject(error);
			}
		};
	},
	reorderCategories: (reorderCategoriesRequest: ReorderCategoriesRequest) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<ReorderCategoriesSuccessfulAction> => {
			const reorderCategoriesRequestedAction: ReorderCategoryRequestedAction =
				{
					type: QbrActionTypes.REORDER_QBR_CATEGORIES_REQUESTED
				};
			dispatch(reorderCategoriesRequestedAction);
			try {
				const reorderCategoriesResponse = await reorderCategories(
					reorderCategoriesRequest
				);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedQbrBlocks(state, {
						riskMatrix: false,
						riskScore: false,
						healthStatus: true
					});
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const reorderCategoriesSuccessfulAction: ReorderCategoriesSuccessfulAction =
					{
						type: QbrActionTypes.REORDER_QBR_CATEGORIES_SUCCESS,
						currentActiveQbr: reorderCategoriesResponse
					};
				return dispatch(reorderCategoriesSuccessfulAction);
			} catch (error) {
				const reorderCategoriesFailedAction: ReorderCategoryFailedAction =
					{
						type: QbrActionTypes.REORDER_QBR_CATEGORIES_FAILED
					};
				dispatch(reorderCategoriesFailedAction);

				return Promise.reject(error);
			}
		};
	}
};

export default QbrActionCreators;
